import { useEffect, useRef, useState, useCallback } from 'react';
import { breakpoints, useIsomorphicLayoutEffect } from '@singita/components';
import { isBrowser } from '../../../singita-web/src/common/constants';

const useActionBar = (breakpoint = 'md') => {
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  const ref = useRef(null);
  const [isMobile, setIsMobile] = useState(false);

  const checkWidth = useCallback(() => {
    if (isBrowser && ref?.current) {
      const { width } = ref.current.getBoundingClientRect();
      if (width < breakpoints[breakpoint]) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    }
  }, [ref, breakpoint, setIsMobile]);

  useEffect(() => {
    window.addEventListener('resize', checkWidth);
    return () => window.removeEventListener('resize', checkWidth);
  });

  useIsomorphicLayoutEffect(() => {
    isMounted && checkWidth();
  }, [isMounted, checkWidth]);

  return [ref, isMobile];
};

export default useActionBar;
